// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"116":"daf39cefecd1414d","185":"5d2b18e2797a8fcb"}[chunkId] + ".css";
};